export default __webpack_public_path__ + "static/media/state.ef3a305c.svg";